import { store } from 'src/infra/stores/store';
import { selectSelectedBilledEntities } from 'src/infra/stores/reducer/billedEntitiesSlice';
import { userStore } from 'src/use-cases/user/userDetails/userStore';
import { getAllEntityCodes } from './getAllEntityCodes';

/**
 * Returns the current billed entity IDs as a comma-separated string,
 * or null if none are available.
 * Reuses the same logic as billedEntitiesInterceptor.
 * Always reads fresh from the Redux store to avoid stale cache across sessions.
 */
export function getBilledEntityIds(): string | null {
  const state = store.getState();
  const selectedEntities = selectSelectedBilledEntities(state);
  const entityCodes = getAllEntityCodes(selectedEntities);

  if (entityCodes.length > 0) {
    return entityCodes.join(',');
  }

  const defaultBilledEntityId = userStore.getDefaultBilledEntityId();
  if (defaultBilledEntityId) {
    return defaultBilledEntityId;
  }

  return null;
}
